import { render, staticRenderFns } from "./cooperationApply.vue?vue&type=template&id=4d1255a0&scoped=true&"
import script from "./cooperationApply.vue?vue&type=script&lang=js&"
export * from "./cooperationApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1255a0",
  null
  
)

export default component.exports